/**
 * Texto seguro para insertar en innerHTML (evita XSS en vistas armadas con template strings).
 */
export function escapeHtml(s) {
  const d = document.createElement('div');
  d.textContent = s ?? '';
  return d.innerHTML;
}
